import { useTranslation } from 'react-i18next';
import { AiOutlineLoading } from 'react-icons/ai';

interface LoadingProps {
  message?: string;
}

export default function Loading({ message }: LoadingProps = {}) {
  const { t, ready } = useTranslation();
  
  // Display a default loading message or use the provided message
  const displayMessage = message || (ready ? t('Loading') : 'Loading');

  return (
    <div className="w-full h-screen bg-white dark:bg-transparent">
      <div className="flex h-full flex-col items-center justify-center gap-4">
        <div className="relative w-10 h-10">
          <AiOutlineLoading
            size={40}
            className="animate-spin text-[#8c33e6] dark:text-[#a864eb]"
          />
        </div>
        <span className="text-gray-800 dark:text-gray-200 text-sm mt-2">
          {displayMessage}...
        </span>
      </div>
    </div>
  );
}
